export const REQUEST_FETCH_COLLECTION_EM = "REQUEST_FETCH_COLLECTION_EM"
export const FETCH_COLLECTION_EM_SUCCESS = "FETCH_COLLECTION_EM_SUCCESS"
export const FETCH_COLLECTION_EM_FAILURE = "FETCH_COLLECTION_EM_FAILURE"

export const CLEAR_FETCH_COLLECTION_EM_STATES = "CLEAR_FETCH_COLLECTION_EM_STATES"